export const ICON_BG_FALL_BACK_COLOR = '#3fb9fc';
